import * as React from 'react';
import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import Typography from '@mui/material/Typography';
// import { Link } from 'react-router-dom';
import { useTranslation } from 'services/localization/useTranslation';

type Props = WithStyles<typeof styles>;

export const TestPaymentAlert = (props: Props) => {
	const { t } = useTranslation();
	return (
		<div className={props.classes.wrapper}>
			<Typography variant="body2">
				{t(
					'headerBar.linkTestPaymentInfo',
					'Currently you can only do TEST payments with the rental link. With live rentals, use a different payment method',
				)}
				.
			</Typography>
		</div>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		wrapper: {
			width: '100%',
			padding: '16px',
			background: theme.palette.background.secondary,
		},
		link: {
			fontWeight: 500,
			color: theme.palette.primary.main,
		},
	});

export default withStyles(styles)(TestPaymentAlert);
